module.exports = __webpack_public_path__ + "static/media/card-American-Express-mobile.3d46a3c9.svg";